import { Deserializable } from '../../protocols/deserializable';
import { Attachment } from '../attachment';

export class EmployerSubmissionLogo implements Deserializable {
  public id!: string;
  public employerId!: string;
  public attachment!: Attachment;

  public onDeserialize(): void {
    if (!!this.attachment) {
      this.attachment = window.injector.Deserialize.instanceOf(Attachment, this.attachment);
    }
  }
}
